module.exports = __webpack_public_path__ + "static/img-iphone-and-laptop-dashboard@2x.d415ae75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-iphone-and-laptop-dashboard@2x.png
// module id = 789
// module chunks = 35783957827783